<template>
    <div class="order">
        <div class="search m-b-20">
            <div class="search-box flex-row">
                <img class="searchImg" :src="search" alt="" >
                <input class="searchVal" placeholder="请输入关键字搜索" v-model="value" type="text">
            </div>
        </div>
        <ul class="orderList" >
            <li class="item m-b-20" v-for="(item, index) in orderList" :key="index" @click="viewPage(item.orderNumber)">
                <div class="title brder-b flex-row">
                    <p class="orderNumber">订单号：{{item.orderNumber}}</p>
                    <div class="orderStats">
                        <span v-if="item.status == 1">待处理</span>
                        <span v-if="item.status == 2">进行中</span>
                        <span v-if="item.status == 3">已完成</span>
                    </div>
                </div>
                <div class="product flex-row m-t-25 m-b-20">
                    <p>报修原因：{{item.repairReasons}}</p>
                    <span class="time">报修时间：{{item.repairTime}}</span>
                </div>
                <div class="product flex-row m-t-25 m-b-20" v-if="item.status != 1">
                    <p>最后受理时间：{{item.handleTime}}</p>
                    <span class="time">最后受理人：{{item.handleName}}</span>
                </div>
                <div class="flex-row contractImg" v-for="(imgs, i) in item" :key="i">
                    <img :src="imgs" alt="">
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import search from '@/assets/img/search.png';
import product from '@/assets/img/product.jpg';
import tel from '@/assets/img/tel.png';
import { listQuestionnaire,listOrder } from '@/api/index';
export default {
    data(){
        return {
            search,
            product,
            tel,
            value:'',
            orderList:[]
        }
    },
    created(){
        console.log(1);
        this.getData();
    },
    methods:{
        viewPage(item){
            this.$router.push({path:'/contractInfo',query:{numbers: item}});
        },
        /**
         * 获取保修列表
         * @method getData
         */
        getData(){
            let data = this.$loca.getItem('phone');                      
            listQuestionnaire({phone: data, orderNumber: this.value}).then(res => {
                res.data.forEach(item => {
                    item.accessoryNames = item.accessoryNames.split('.');
                });
                this.orderList = res.data;
            }).catch(error => {
                console.log('获取保修 views/contract/index');
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.order{
    background: $color-ed;
    .search{
        height: 82px;
        background: $ffff;
        .search-box{
            width:670px;
            height:60px;
            background:rgba(255,255,255,1);
            border:2px solid rgba(229,229,229,1);
            border-radius:10px;
            margin:18px 0 0 39px;
            align-items: center;
            .searchImg{
                margin-left: 17px;
                width: 24px;
                height: 24px;
            }
            .searchVal{
                margin-left: 18px;
                width: 600px;
                height: 100%;
            }
        }
    }
    .orderList{
        background: $color-ed;
        .item{
            // height: 334px;
            background: $ffff;
            padding: 0 20px;
            padding-bottom: 2px;
            .title{
                padding: 18px 0 15px 0; 
                justify-content: space-between;
                .orderNumber{
                    font-size:28px;
                    color:rgba(51,51,51,1);
                    margin-left: 18px;
                }
                .orderStats{
                    font-size:20px;
                    color:rgba(86,180,240,1);
                    margin-right: 11px;
                    span{
                        margin-left: 15px;
                    }
                }
            }
            .product{
                margin-left: 14px;
                font-size:24px;
                color: #000000;
                justify-content: space-between;
                align-items: center;
                .time{
                    margin-right: 11px;
                    font-size:20px;
                }
                .numbers{
                    font-size:24px;
                    color:$color-81;
                }
                .invoice{
                    margin-right: 11px;
                    font-size:20px;
                    color:$color-153;
                }
            }
            .info{
                padding: 16px 0 10px 0;
                font-size:24px;
                color:$color-153;
                width: auto;
                align-items: center;
                justify-content: space-between;
                img{
                    width: 54px;
                    height: 54px;
                }
                .information{
                    align-items:center;
                    .names{
                        margin-bottom: 7px;
                    }
                    img{
                        width: 65px;
                        height: 65px;
                        margin: 0 25px 0 21px;
                    }
                }
            }
        }
    }
}
.delivery{
    color:$color-162;
}
.contractImg{
    margin-left: 20px;
    padding-bottom: 15px;
    img{
        width: 140px;
        height: 100px;
        margin-right: 10px;
    }
}
</style>

